<template>
  <div id="app">
    <div v-if="noUpdated">
      <SearchRep></SearchRep>
      <UpdateRep :obj-rep="this.$store.state.repData"></UpdateRep>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import SearchRep from "./components/SearchRep";
import UpdateRep from "./components/UpdateRep";

export default {
  name: "App",
  components: {
    SearchRep: SearchRep,
    UpdateRep: UpdateRep
  },
  data: function() {
    return {
      objRep: [],
      noUpdated: true
    };
  },
  computed: {
    ...mapState(["contractNumber", "repData", "wasUpdated"])
  },
  created: function() {
    // To get the value of a cookie use
    if (this.$cookie.get("AvonRep") !== null) {
      //alert("cookie exists");
      this.noUpdated = false;
    }
  }
};
</script>

<style>
.toast-container > .toast-warning {
  background-color: orange;
}
input:invalid {
  border-color: red;
}
input[aria-invalid="true"] {
  border-color: red;
}
input[aria-invalid="false"] {
  border-color: green;
}
.errors {
  color: darkred;
  font-size: smaller;
}
</style>
